<template>
  <div id="app" style="min-height: 100%; display: flex; flex-direction: column">
    <div style="flex: 1; display: flex; flex-direction: column">
      <router-view />
    </div>
    <Footer />
    <GlobalSavingOverlay />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import GlobalSavingOverlay from "./components/GlobalSavingOverlay.vue";

export default {
  components: {
    Footer,
    GlobalSavingOverlay,
  },
};
</script>

<style>
html {
  height: 100%;
  box-sizing: border-box;
}

body {
  font-family: "TangoSans";
  position: relative;
  margin: 0;
  min-height: 100%;
  box-sizing: inherit;
  height: 100%;
}

@font-face {
  font-family: "Amanise";
  src: url("./assets/fonts/Amanise.ttf");
  font-style: normal;
}

@font-face {
  font-family: "Redressed";
  src: url("./assets/fonts/Redressed-Regular.ttf");
  font-style: normal;
}

@font-face {
  font-family: "Merriweather";
  src: url("./assets/fonts/Merriweather-Regular.ttf");
  font-style: normal;
}

@font-face {
  font-family: "TangoSans";
  src: url("./assets/fonts/TangoSans.ttf");
  font-weight: normal;
  font-style: normal;
}

.tangosans {
  font-family: "TangoSans";
}

.amanise {
  font-family: "Amanise";
}

.merriweather {
  font-family: "Merriweather";
}

.redressed {
  font-family: "Redressed";
}
</style>
